import { Link } from 'react-router-dom';
import PrivateContent from '@routes';
import Logo from '@assets/images/logo.png';
import styles from './index.module.scss';
import cs from 'classnames';
import Info from '@assets/images/ai1.png';

const Header = () => {
  // const navigate = useNavigate();
  // const logoutHandler = () => {
  //   localStorage.clear();
  //   navigate('/', { replace: true });
  // };

  const LoggedOutStartItems = (
    <>
      <Link to={'/login'} replace={true} className="main-title">
        Login
      </Link>
      <Link to={'/register'} replace={true} className="main-title">
        Register
      </Link>
    </>
  );
  const LoggedInStartItems = (
    <>
      <Link
        to={'/dashboard'}
        replace={true}
        className={cs(['main-title', styles['dashboard_tlt']])}>
        <span>Dashboard</span>
        <img src={Info} alt="Info Image" className={styles['info_img']} />
      </Link>
    </>
  );
  return (
    <>
      <div className={styles['header']}>
        <div className={styles['logo']}>
          <Link to={'/'}>
            {' '}
            <img src={Logo} width={203} height={55} alt="Logo Image" />
          </Link>
        </div>
        <div className={styles['login-reg']}>
          <PrivateContent
            component={() => LoggedInStartItems}
            replaceComponent={() => LoggedOutStartItems}
            title={''}
          />
        </div>
      </div>
    </>
  );
};

export default Header;
